import { getSettingRetailerExclusivityAgreements } from "@faire/help-center-utils/settings/getSettingRetailerExclusivityAgreements";
export var HowDoesSignupWorkIA = function HowDoesSignupWorkIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(_context) {
      return HOW_DOES_SIGNUP_OFFER_WORK_TITLE(strictLocalize);
    },
    descriptionBuilder: function descriptionBuilder(_context) {
      return [HOW_DOES_SIGNUP_OFFER_WORK_DESCRIPTION(strictLocalize)];
    }
  };
};
var HOW_DOES_SIGNUP_OFFER_WORK_TITLE = function HOW_DOES_SIGNUP_OFFER_WORK_TITLE(strictLocalize) {
  if (getSettingRetailerExclusivityAgreements()) {
    return strictLocalize({
      id: "JvfdpN",
      defaultMessage: "How to claim offer"
    });
  } else {
    return strictLocalize({
      id: "w7CyhN",
      defaultMessage: "How does the signup offer work"
    });
  }
};
var HOW_DOES_SIGNUP_OFFER_WORK_DESCRIPTION = function HOW_DOES_SIGNUP_OFFER_WORK_DESCRIPTION(strictLocalize) {
  return strictLocalize({
    id: "x52u0e",
    defaultMessage: "When you join Faire using a brand’s link, you’ll receive a signup offer, including a promotion and one year of free shipping with that brand. The offer is automatically applied at checkout and expires 7 days after signing up."
  });
};